/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
};

export type AdditionalPair = {
  __typename?: 'AdditionalPair';
  childFirstName: Scalars['String']['output'];
  childLastName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type AdditionalPairInput = {
  childFirstName: Scalars['String']['input'];
  childLastName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export enum AgeGroup {
  Adult = 'ADULT',
  Teenager = 'TEENAGER'
}

export type Agreement = {
  __typename?: 'Agreement';
  consent: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  type: AgreementType;
};

export type AgreementInput = {
  consent: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
  type: AgreementType;
};

export enum AgreementType {
  Health = 'Health',
  Newsletter = 'Newsletter',
  Photo = 'Photo',
  Privacy = 'Privacy',
  Terms = 'Terms'
}

export type AnswerSnapshot = {
  __typename?: 'AnswerSnapshot';
  open?: Maybe<SurveyAnswerInputType>;
  text: Scalars['String']['output'];
};

export type CampInput = {
  bankAccountNumber: Scalars['String']['input'];
  boatFee: Scalars['String']['input'];
  deposit: Scalars['String']['input'];
  description: Scalars['String']['input'];
  range: Scalars['String']['input'];
  remainingAmount: Scalars['String']['input'];
  remainingDueDate: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CampRegisterInput = {
  additionalPairs?: InputMaybe<Array<AdditionalPairInput>>;
  agreements?: InputMaybe<Array<AgreementInput>>;
  camp: CampInput;
  childFirstName: Scalars['String']['input'];
  childLastName: Scalars['String']['input'];
  confirmationUrl: Scalars['String']['input'];
  email: Scalars['String']['input'];
  files?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CampRegistration = {
  __typename?: 'CampRegistration';
  additionalPairs?: Maybe<Array<AdditionalPair>>;
  agreements?: Maybe<Array<Agreement>>;
  child: Child;
  confirmed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  id: Scalars['Int']['output'];
  registrationId: Scalars['String']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Child = {
  __typename?: 'Child';
  campRegistrations: Array<CampRegistration>;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  age: AgeGroup;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContactFormInput = {
  age: AgeGroup;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type CreateGroupDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateScaleAnswerInput = {
  points?: Scalars['Int']['input'];
  scaleId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export type CreateScaleDomainKeyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  domainName: Scalars['String']['input'];
  questionIds: Array<Scalars['Int']['input']>;
  scaleId: Scalars['Int']['input'];
};

export type CreateScaleDomainKeyRangeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  domainKeyId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
  maxValue: Scalars['Float']['input'];
  minValue: Scalars['Float']['input'];
};

export type CreateScaleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  domainKeys?: InputMaybe<Array<CreateScaleDomainKeyInput>>;
  parent?: InputMaybe<Scalars['Boolean']['input']>;
  requiresKnowledgeAccess?: InputMaybe<Scalars['Boolean']['input']>;
  resultRangeType?: InputMaybe<ScaleResultRangeType>;
  resultRanges?: InputMaybe<Array<CreateScaleResultRangeInput>>;
  teenager?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type CreateScaleQuestionInput = {
  isReversed?: Scalars['Boolean']['input'];
  scaleId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export type CreateScaleResultRangeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  maxPoints: Scalars['Int']['input'];
  minPoints: Scalars['Int']['input'];
  scaleId: Scalars['Int']['input'];
};

export type CreateSurveyAnswerInput = {
  open?: InputMaybe<SurveyAnswerInputType>;
  questionId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export type CreateSurveyInput = {
  parent?: InputMaybe<Scalars['Boolean']['input']>;
  requiresKnowledgeAccess?: InputMaybe<Scalars['Boolean']['input']>;
  teenager?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type CreateSurveyQuestionInput = {
  multi?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sectionId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export type CreateSurveySectionInput = {
  compact?: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  surveyId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type CreateUserDto = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  campRegistrations: Array<CampRegistration>;
  children: Array<Child>;
  contacts: Array<Contact>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Group = {
  __typename?: 'Group';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  users: Array<User>;
};

export type GroupOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type KnowledgeAccessGrant = {
  __typename?: 'KnowledgeAccessGrant';
  accessEndsAt: Scalars['DateTime']['output'];
};

export type KnowledgeAccessPolicy = {
  __typename?: 'KnowledgeAccessPolicy';
  scales: Array<KnowledgeAccessPolicyEntry>;
  surveys: Array<KnowledgeAccessPolicyEntry>;
};

export type KnowledgeAccessPolicyEntry = {
  __typename?: 'KnowledgeAccessPolicyEntry';
  id: Scalars['Int']['output'];
  requiresKnowledgeAccess: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addPermissionToGroup: Scalars['Boolean']['output'];
  addUserToGroup: Scalars['Boolean']['output'];
  campRegister: CampRegistration;
  confirmCampRegistration: CampRegistration;
  contact: Contact;
  createGroup: Group;
  createScale: Scale;
  createScaleAnswer: ScaleAnswer;
  createScaleDomainKey: ScaleDomainKey;
  createScaleDomainKeyRange: ScaleDomainKeyRange;
  createScaleQuestion: ScaleQuestion;
  createScaleResultRange: ScaleResultRange;
  createSurvey: Survey;
  createSurveyAnswer: SurveyAnswer;
  createSurveyQuestion: SurveyQuestion;
  createSurveySection: SurveySection;
  /** Create a new user */
  createUser: User;
  forgotPassword: Scalars['Boolean']['output'];
  login: UserWithTokens;
  logout: Scalars['Boolean']['output'];
  newsletterSignup: Customer;
  refreshTokens: Tokens;
  removeGroup: Scalars['Boolean']['output'];
  removePermissionFromGroup: Scalars['Boolean']['output'];
  removeScale: Scalars['Boolean']['output'];
  removeScaleAnswer: Scalars['Boolean']['output'];
  removeScaleDomainKey: Scalars['Boolean']['output'];
  removeScaleDomainKeyRange: Scalars['Boolean']['output'];
  removeScaleQuestion: Scalars['Boolean']['output'];
  removeScaleResultRange: Scalars['Boolean']['output'];
  removeSurvey: Scalars['Boolean']['output'];
  removeSurveyAnswer: Scalars['Boolean']['output'];
  removeSurveyQuestion: Scalars['Boolean']['output'];
  removeSurveySection: Scalars['Boolean']['output'];
  /** Delete a user */
  removeUser: Scalars['Boolean']['output'];
  removeUserFromGroup: Scalars['Boolean']['output'];
  reorderQuestionAnswers: Scalars['Boolean']['output'];
  reorderScaleAnswers: Scalars['Boolean']['output'];
  reorderScaleQuestions: Scalars['Boolean']['output'];
  reorderSectionQuestions: Scalars['Boolean']['output'];
  reorderSurveySections: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  signUp: UserWithTokens;
  startScaleResponseWithFirstQuestion: StartScaleResponseResult;
  startSurveyResponseWithFirstSection: StartSurveyResponseResult;
  submitScaleResponse: ScaleResponseResult;
  submitSurveyResponses: SurveyResponsesResult;
  updateGroup: Group;
  updateGroupPermissions: Group;
  updateScale: Scale;
  updateScaleAnswer: ScaleAnswer;
  updateScaleDomainKey: ScaleDomainKey;
  updateScaleDomainKeyRange: ScaleDomainKeyRange;
  updateScaleQuestion: ScaleQuestion;
  updateScaleResultRange: ScaleResultRange;
  updateSurvey: Survey;
  updateSurveyAnswer: SurveyAnswer;
  updateSurveyQuestion: SurveyQuestion;
  updateSurveySection: SurveySection;
  /** Update an existing user */
  updateUser: User;
};


export type MutationAddPermissionToGroupArgs = {
  groupId: Scalars['Int']['input'];
  permissionId: Scalars['Int']['input'];
};


export type MutationAddUserToGroupArgs = {
  groupId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationCampRegisterArgs = {
  campRegisterInput: CampRegisterInput;
};


export type MutationConfirmCampRegistrationArgs = {
  token: Scalars['String']['input'];
};


export type MutationContactArgs = {
  contactFormInput: ContactFormInput;
};


export type MutationCreateGroupArgs = {
  createGroupInput: CreateGroupDto;
};


export type MutationCreateScaleArgs = {
  input: CreateScaleInput;
};


export type MutationCreateScaleAnswerArgs = {
  input: CreateScaleAnswerInput;
};


export type MutationCreateScaleDomainKeyArgs = {
  input: CreateScaleDomainKeyInput;
};


export type MutationCreateScaleDomainKeyRangeArgs = {
  input: CreateScaleDomainKeyRangeInput;
};


export type MutationCreateScaleQuestionArgs = {
  input: CreateScaleQuestionInput;
};


export type MutationCreateScaleResultRangeArgs = {
  input: CreateScaleResultRangeInput;
};


export type MutationCreateSurveyArgs = {
  createSurveyInput: CreateSurveyInput;
};


export type MutationCreateSurveyAnswerArgs = {
  createAnswerInput: CreateSurveyAnswerInput;
};


export type MutationCreateSurveyQuestionArgs = {
  createQuestionInput: CreateSurveyQuestionInput;
};


export type MutationCreateSurveySectionArgs = {
  createSectionInput: CreateSurveySectionInput;
};


export type MutationCreateUserArgs = {
  createUserInput: CreateUserDto;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
  resetUrl: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationNewsletterSignupArgs = {
  newsletterSignupInput: NewsletterSignupInput;
};


export type MutationRemoveGroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePermissionFromGroupArgs = {
  groupId: Scalars['Int']['input'];
  permissionId: Scalars['Int']['input'];
};


export type MutationRemoveScaleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveScaleAnswerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveScaleDomainKeyArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveScaleDomainKeyRangeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveScaleQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveScaleResultRangeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSurveyArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSurveyAnswerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSurveyQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSurveySectionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserFromGroupArgs = {
  groupId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationReorderQuestionAnswersArgs = {
  input: ReorderItemsInput;
};


export type MutationReorderScaleAnswersArgs = {
  input: ReorderItemsInput;
};


export type MutationReorderScaleQuestionsArgs = {
  input: ReorderItemsInput;
};


export type MutationReorderSectionQuestionsArgs = {
  input: ReorderItemsInput;
};


export type MutationReorderSurveySectionsArgs = {
  input: ReorderItemsInput;
};


export type MutationResetPasswordArgs = {
  reset: ResetPasswordDto;
};


export type MutationSignUpArgs = {
  user: CreateUserDto;
};


export type MutationStartScaleResponseWithFirstQuestionArgs = {
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  knowledgeAccessGrantUid?: InputMaybe<Scalars['ID']['input']>;
  scaleUid: Scalars['ID']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartSurveyResponseWithFirstSectionArgs = {
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  knowledgeAccessGrantUid?: InputMaybe<Scalars['ID']['input']>;
  surveyUid: Scalars['ID']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitScaleResponseArgs = {
  input: ScaleResponseInput;
};


export type MutationSubmitSurveyResponsesArgs = {
  input: SurveyResponsesInput;
};


export type MutationUpdateGroupArgs = {
  updateGroupInput: UpdateGroupInput;
};


export type MutationUpdateGroupPermissionsArgs = {
  groupId: Scalars['Int']['input'];
  permissionIds: Array<Scalars['Int']['input']>;
};


export type MutationUpdateScaleArgs = {
  id: Scalars['Int']['input'];
  input: UpdateScaleInput;
};


export type MutationUpdateScaleAnswerArgs = {
  id: Scalars['Int']['input'];
  input: UpdateScaleAnswerInput;
};


export type MutationUpdateScaleDomainKeyArgs = {
  input: UpdateScaleDomainKeyInput;
};


export type MutationUpdateScaleDomainKeyRangeArgs = {
  id: Scalars['Int']['input'];
  input: UpdateScaleDomainKeyRangeInput;
};


export type MutationUpdateScaleQuestionArgs = {
  id: Scalars['Int']['input'];
  input: UpdateScaleQuestionInput;
};


export type MutationUpdateScaleResultRangeArgs = {
  input: UpdateScaleResultRangeInput;
};


export type MutationUpdateSurveyArgs = {
  updateSurveyInput: UpdateSurveyInput;
};


export type MutationUpdateSurveyAnswerArgs = {
  updateAnswerInput: UpdateSurveyAnswerInput;
};


export type MutationUpdateSurveyQuestionArgs = {
  updateQuestionInput: UpdateSurveyQuestionInput;
};


export type MutationUpdateSurveySectionArgs = {
  updateSectionInput: UpdateSurveySectionInput;
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};

export type NewsletterSignupInput = {
  /** Email address */
  email: Scalars['String']['input'];
};

export type Permission = {
  __typename?: 'Permission';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Query = {
  __typename?: 'Query';
  calculateDomainScore: Scalars['Float']['output'];
  getResultForPoints?: Maybe<ScaleResultRange>;
  group: Group;
  groups: Array<Group>;
  knowledgeAccessGrant?: Maybe<KnowledgeAccessGrant>;
  knowledgeAccessPolicy: KnowledgeAccessPolicy;
  me: User;
  permissions: Array<Permission>;
  ping: Scalars['Boolean']['output'];
  previewScaleCompletionResult: ScaleResponseResult;
  previewSurveyCompletionResult: SurveyCompletionPreviewResult;
  scale: Scale;
  scaleAnswer: ScaleAnswer;
  scaleAnswers: Array<ScaleAnswer>;
  scaleDomainKey: ScaleDomainKey;
  scaleDomainKeyRange: ScaleDomainKeyRange;
  scaleDomainKeyRanges: Array<ScaleDomainKeyRange>;
  scaleDomainKeys: Array<ScaleDomainKey>;
  scaleDomainKeysByScale: Array<ScaleDomainKey>;
  scaleQuestion: ScaleQuestion;
  scaleQuestions: Array<ScaleQuestion>;
  scaleResponse: ScaleResponse;
  scaleResponses: Array<ScaleResponse>;
  scaleResultRange: ScaleResultRange;
  scaleResultRanges: Array<ScaleResultRange>;
  scaleResultRangesByScale: Array<ScaleResultRange>;
  scales: Array<Scale>;
  scalesForKnowledgeAccessGrant: Array<Scale>;
  survey: Survey;
  surveyAnswer: SurveyAnswer;
  surveyQuestion: SurveyQuestion;
  surveyQuestionResponses: Array<SurveyQuestionResponse>;
  surveyResponse: SurveyResponse;
  surveyResponses: Array<SurveyResponse>;
  surveySection: SurveySection;
  surveys: Array<Survey>;
  surveysForKnowledgeAccessGrant: Array<Survey>;
  /** Find user by ID */
  user: User;
  /** The users resolver */
  users: Array<User>;
};


export type QueryCalculateDomainScoreArgs = {
  domainName: Scalars['String']['input'];
  questionResponses: Array<QuestionResponseInput>;
  scaleId: Scalars['Int']['input'];
};


export type QueryGetResultForPointsArgs = {
  points: Scalars['Int']['input'];
  scaleId: Scalars['Int']['input'];
};


export type QueryGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGroupsArgs = {
  orderBy?: InputMaybe<GroupOrderBy>;
};


export type QueryKnowledgeAccessGrantArgs = {
  knowledgeAccessGrantUid: Scalars['ID']['input'];
};


export type QueryPreviewScaleCompletionResultArgs = {
  resultPoints: Array<Scalars['Float']['input']>;
  scaleUid: Scalars['ID']['input'];
};


export type QueryPreviewSurveyCompletionResultArgs = {
  surveyUid: Scalars['ID']['input'];
};


export type QueryScaleArgs = {
  id: Scalars['Int']['input'];
  uid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryScaleAnswerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryScaleAnswersArgs = {
  scaleId: Scalars['Int']['input'];
};


export type QueryScaleDomainKeyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryScaleDomainKeyRangeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryScaleDomainKeyRangesArgs = {
  domainKeyId: Scalars['Int']['input'];
};


export type QueryScaleDomainKeysByScaleArgs = {
  scaleId: Scalars['Int']['input'];
};


export type QueryScaleQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryScaleQuestionsArgs = {
  scaleId: Scalars['Int']['input'];
};


export type QueryScaleResponseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryScaleResponsesArgs = {
  scaleId: Scalars['Int']['input'];
};


export type QueryScaleResultRangeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryScaleResultRangesByScaleArgs = {
  scaleId: Scalars['Int']['input'];
};


export type QueryScalesForKnowledgeAccessGrantArgs = {
  knowledgeAccessGrantUid: Scalars['ID']['input'];
};


export type QuerySurveyArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  uid?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySurveyAnswerArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySurveyQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySurveyQuestionResponsesArgs = {
  surveyResponseUid: Scalars['ID']['input'];
};


export type QuerySurveyResponseArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySurveyResponsesArgs = {
  surveyId: Scalars['Int']['input'];
};


export type QuerySurveySectionArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySurveysForKnowledgeAccessGrantArgs = {
  knowledgeAccessGrantUid: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUsersArgs = {
  orderBy?: InputMaybe<UserOrderBy>;
};

export type QuestionResponseInput = {
  points: Scalars['Int']['input'];
  questionNumber: Scalars['Int']['input'];
};

export type QuestionSnapshot = {
  __typename?: 'QuestionSnapshot';
  multi: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type ReorderItemsInput = {
  /** Array of item IDs in new order */
  itemIds: Array<Scalars['Int']['input']>;
};

export type ResetPasswordDto = {
  password: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
};

export type Scale = {
  __typename?: 'Scale';
  answers: Array<ScaleAnswer>;
  consistencyError?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  domainKeys: Array<ScaleDomainKey>;
  id: Scalars['Int']['output'];
  parent?: Maybe<Scalars['Boolean']['output']>;
  questions: Array<ScaleQuestion>;
  questionsCount: Scalars['Int']['output'];
  requiresKnowledgeAccess: Scalars['Boolean']['output'];
  responsesCount: Scalars['Int']['output'];
  resultRangeType: ScaleResultRangeType;
  resultRanges: Array<ScaleResultRange>;
  teenager?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ScaleAnswer = {
  __typename?: 'ScaleAnswer';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
  scaleId: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ScaleAnswerDto = {
  __typename?: 'ScaleAnswerDTO';
  text: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type ScaleCompletionResult = {
  __typename?: 'ScaleCompletionResult';
  domainScores?: Maybe<Array<ScaleDomainScoreItem>>;
  resultRange?: Maybe<ScaleResultRangeSummary>;
  totalPoints: Scalars['Float']['output'];
};

export type ScaleDomainKey = {
  __typename?: 'ScaleDomainKey';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  domainName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  questions: Array<ScaleQuestion>;
  ranges: Array<ScaleDomainKeyRange>;
  scaleId: Scalars['Int']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ScaleDomainKeyRange = {
  __typename?: 'ScaleDomainKeyRange';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  domainKeyId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  maxValue: Scalars['Float']['output'];
  minValue: Scalars['Float']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ScaleDomainScoreItem = {
  __typename?: 'ScaleDomainScoreItem';
  description: Scalars['String']['output'];
  domainName: Scalars['String']['output'];
  range?: Maybe<ScaleDomainKeyRange>;
  score: Scalars['Float']['output'];
};

export type ScaleQuestion = {
  __typename?: 'ScaleQuestion';
  createdAt: Scalars['DateTime']['output'];
  domainKeys: Array<ScaleDomainKey>;
  id: Scalars['Int']['output'];
  isReversed: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scaleId: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ScaleQuestionDto = {
  __typename?: 'ScaleQuestionDTO';
  text: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type ScaleQuestionResponse = {
  __typename?: 'ScaleQuestionResponse';
  answer: ScaleAnswer;
  answerId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  question: ScaleQuestion;
  questionId: Scalars['Int']['output'];
  scaleResponse: ScaleResponse;
  scaleResponseId: Scalars['Int']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ScaleResponse = {
  __typename?: 'ScaleResponse';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completionPercentage: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  questionResponses: Array<ScaleQuestionResponse>;
  scaleId: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ScaleResponseStatus;
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type ScaleResponseInput = {
  answerUid: Scalars['String']['input'];
  questionUid: Scalars['ID']['input'];
  scaleResponseUid: Scalars['ID']['input'];
};

export type ScaleResponseResult = {
  __typename?: 'ScaleResponseResult';
  isCompleted: Scalars['Boolean']['output'];
  question?: Maybe<ScaleQuestion>;
  result?: Maybe<ScaleCompletionResult>;
};

export enum ScaleResponseStatus {
  Abandoned = 'ABANDONED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type ScaleResultRange = {
  __typename?: 'ScaleResultRange';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  maxPoints: Scalars['Int']['output'];
  minPoints: Scalars['Int']['output'];
  scaleId: Scalars['Int']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ScaleResultRangeSummary = {
  __typename?: 'ScaleResultRangeSummary';
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

/** Type of values used in the scale (points or percentage) */
export enum ScaleResultRangeType {
  Average = 'AVERAGE',
  Sum = 'SUM'
}

/** Sort order for queries */
export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StartScaleResponseResult = {
  __typename?: 'StartScaleResponseResult';
  answers: Array<ScaleAnswerDto>;
  firstQuestion: ScaleQuestionDto;
  scaleResponse: ScaleResponse;
};

export type StartSurveyResponseResult = {
  __typename?: 'StartSurveyResponseResult';
  firstSection: SurveySectionWithStatus;
  surveyResponse: SurveyResponse;
};

export type Survey = {
  __typename?: 'Survey';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  parent?: Maybe<Scalars['Boolean']['output']>;
  questionsCount: Scalars['Int']['output'];
  requiresKnowledgeAccess: Scalars['Boolean']['output'];
  responsesCount: Scalars['Int']['output'];
  sections: Array<SurveySection>;
  teenager?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type SurveySectionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SurveyAnswer = {
  __typename?: 'SurveyAnswer';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  open?: Maybe<SurveyAnswerInputType>;
  text: Scalars['String']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of input field for open-ended answers */
export enum SurveyAnswerInputType {
  Input = 'INPUT',
  Textarea = 'TEXTAREA'
}

export type SurveyCompletionPreviewResult = {
  __typename?: 'SurveyCompletionPreviewResult';
  rows: Array<SurveyCompletionPreviewRow>;
};

export type SurveyCompletionPreviewRow = {
  __typename?: 'SurveyCompletionPreviewRow';
  description: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  answers: Array<SurveyAnswer>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  multi?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  text: Scalars['String']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SurveyQuestionResponse = {
  __typename?: 'SurveyQuestionResponse';
  answerSnapshot?: Maybe<AnswerSnapshot>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  openResponse?: Maybe<Scalars['String']['output']>;
  question: SurveyQuestion;
  questionSnapshot?: Maybe<QuestionSnapshot>;
  selectedAnswer?: Maybe<SurveyAnswer>;
  surveyResponse: SurveyResponse;
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SurveyQuestionResponseInput = {
  openResponse?: InputMaybe<Scalars['String']['input']>;
  questionUid: Scalars['ID']['input'];
  selectedAnswerUids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SurveyQuestionWithStatus = {
  __typename?: 'SurveyQuestionWithStatus';
  answers: Array<SurveyAnswer>;
  multi: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completionPercentage: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  lastResponseAt?: Maybe<Scalars['DateTime']['output']>;
  questionResponses: Array<SurveyQuestionResponse>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: SurveyResponseStatus;
  survey: Survey;
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

export enum SurveyResponseStatus {
  Abandoned = 'ABANDONED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type SurveyResponsesInput = {
  responses: Array<SurveyQuestionResponseInput>;
  surveyResponseUid: Scalars['ID']['input'];
};

export type SurveyResponsesResult = {
  __typename?: 'SurveyResponsesResult';
  isCompleted: Scalars['Boolean']['output'];
  section?: Maybe<SurveySectionWithStatus>;
};

export type SurveySection = {
  __typename?: 'SurveySection';
  compact: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  questions: Array<SurveyQuestion>;
  title?: Maybe<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SurveySectionWithStatus = {
  __typename?: 'SurveySectionWithStatus';
  compact: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  questions: Array<SurveyQuestionWithStatus>;
  title?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type Tokens = {
  __typename?: 'Tokens';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type UpdateGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScaleAnswerInput = {
  points?: InputMaybe<Scalars['Int']['input']>;
  scaleId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScaleDomainKeyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  domainName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  questionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scaleId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateScaleDomainKeyRangeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  domainKeyId?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateScaleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  domainKeys?: InputMaybe<Array<CreateScaleDomainKeyInput>>;
  parent?: InputMaybe<Scalars['Boolean']['input']>;
  requiresKnowledgeAccess?: InputMaybe<Scalars['Boolean']['input']>;
  resultRangeType?: InputMaybe<ScaleResultRangeType>;
  resultRanges?: InputMaybe<Array<CreateScaleResultRangeInput>>;
  teenager?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScaleQuestionInput = {
  isReversed?: InputMaybe<Scalars['Boolean']['input']>;
  scaleId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScaleResultRangeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  maxPoints?: InputMaybe<Scalars['Int']['input']>;
  minPoints?: InputMaybe<Scalars['Int']['input']>;
  scaleId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSurveyAnswerInput = {
  id: Scalars['Int']['input'];
  open?: InputMaybe<SurveyAnswerInputType>;
  questionId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSurveyInput = {
  id: Scalars['Int']['input'];
  parent?: InputMaybe<Scalars['Boolean']['input']>;
  requiresKnowledgeAccess?: InputMaybe<Scalars['Boolean']['input']>;
  teenager?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSurveyQuestionInput = {
  id: Scalars['Int']['input'];
  multi?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sectionId?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSurveySectionInput = {
  compact?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  surveyId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  groups?: Maybe<Array<Group>>;
  id: Scalars['Int']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UserOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastLoginAt?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
};

export type UserWithTokens = {
  __typename?: 'UserWithTokens';
  accessToken: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  groups?: Maybe<Array<Group>>;
  id: Scalars['Int']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshTokens: { __typename?: 'Tokens', accessToken: string, refreshToken: string } };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', me: { __typename?: 'User', email: string, firstName: string, lastName: string, lastLoginAt?: any | null, createdAt: any, updatedAt: any, groups?: Array<{ __typename?: 'Group', name: string, description?: string | null, permissions: Array<{ __typename?: 'Permission', name?: string | null, description?: string | null }> }> | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type PingQueryVariables = Exact<{ [key: string]: never; }>;


export type PingQuery = { __typename?: 'Query', ping: boolean };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  resetUrl: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type LoginUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginUserMutation = { __typename?: 'Mutation', login: { __typename?: 'UserWithTokens', accessToken: string, refreshToken: string, email: string } };

export type ResetPasswordMutationVariables = Exact<{
  reset: ResetPasswordDto;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type GroupForEditQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GroupForEditQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: number, name: string, description?: string | null, permissions: Array<{ __typename?: 'Permission', id: number, name?: string | null }> } };

export type AllPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPermissionsQuery = { __typename?: 'Query', permissions: Array<{ __typename?: 'Permission', id: number, name?: string | null, description?: string | null }> };

export type UpdateGroupMutationVariables = Exact<{
  updateGroupInput: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup: { __typename?: 'Group', id: number, name: string, description?: string | null } };

export type CreateGroupMutationVariables = Exact<{
  createGroupInput: CreateGroupDto;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'Group', id: number, name: string, description?: string | null } };

export type UpdateGroupPermissionsMutationVariables = Exact<{
  groupId: Scalars['Int']['input'];
  permissionIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type UpdateGroupPermissionsMutation = { __typename?: 'Mutation', updateGroupPermissions: { __typename?: 'Group', id: number, name: string, description?: string | null, permissions: Array<{ __typename?: 'Permission', id: number, name?: string | null }> } };

export type GroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GroupsQuery = { __typename?: 'Query', groups: Array<{ __typename?: 'Group', id: number, createdAt: any, name: string, description?: string | null, permissions: Array<{ __typename?: 'Permission', id: number, name?: string | null }>, users: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> }> };

export type RemoveGroupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveGroupMutation = { __typename?: 'Mutation', removeGroup: boolean };

export type ReorderScaleAnswersMutationVariables = Exact<{
  input: ReorderItemsInput;
}>;


export type ReorderScaleAnswersMutation = { __typename?: 'Mutation', reorderScaleAnswers: boolean };

export type RemoveScaleAnswerMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveScaleAnswerMutation = { __typename?: 'Mutation', removeScaleAnswer: boolean };

export type RemoveScaleDomainKeyMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveScaleDomainKeyMutation = { __typename?: 'Mutation', removeScaleDomainKey: boolean };

export type UpdateScaleDomainKeyInDomainKeysMutationVariables = Exact<{
  input: UpdateScaleDomainKeyInput;
}>;


export type UpdateScaleDomainKeyInDomainKeysMutation = { __typename?: 'Mutation', updateScaleDomainKey: { __typename?: 'ScaleDomainKey', id: number, domainName: string, description?: string | null, questions: Array<{ __typename?: 'ScaleQuestion', id: number, text: string }> } };

export type UpdateScaleResultRangeTypeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  resultRangeType: ScaleResultRangeType;
}>;


export type UpdateScaleResultRangeTypeMutation = { __typename?: 'Mutation', updateScale: { __typename?: 'Scale', id: number, resultRangeType: ScaleResultRangeType } };

export type ScaleDomainKeyRangesQueryVariables = Exact<{
  domainKeyId: Scalars['Int']['input'];
}>;


export type ScaleDomainKeyRangesQuery = { __typename?: 'Query', scaleDomainKeyRanges: Array<{ __typename?: 'ScaleDomainKeyRange', id: number, label: string, minValue: number, maxValue: number, description?: string | null }> };

export type RemoveScaleDomainKeyRangeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveScaleDomainKeyRangeMutation = { __typename?: 'Mutation', removeScaleDomainKeyRange: boolean };

export type ReorderScaleQuestionsMutationVariables = Exact<{
  input: ReorderItemsInput;
}>;


export type ReorderScaleQuestionsMutation = { __typename?: 'Mutation', reorderScaleQuestions: boolean };

export type RemoveScaleQuestionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveScaleQuestionMutation = { __typename?: 'Mutation', removeScaleQuestion: boolean };

export type RemoveScaleResultRangeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveScaleResultRangeMutation = { __typename?: 'Mutation', removeScaleResultRange: boolean };

export type ScaleQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ScaleQuery = { __typename?: 'Query', scale: { __typename?: 'Scale', id: number, title: string, description?: string | null, consistencyError?: string | null, resultRangeType: ScaleResultRangeType, answers: Array<{ __typename?: 'ScaleAnswer', id: number, text: string, points: number }>, questions: Array<{ __typename?: 'ScaleQuestion', id: number, text: string, isReversed: boolean }>, resultRanges: Array<{ __typename?: 'ScaleResultRange', id: number, label: string, minPoints: number, maxPoints: number, description?: string | null }>, domainKeys: Array<{ __typename?: 'ScaleDomainKey', id: number, domainName: string, description?: string | null, questions: Array<{ __typename?: 'ScaleQuestion', id: number, text: string }> }> } };

export type ScalesQueryVariables = Exact<{ [key: string]: never; }>;


export type ScalesQuery = { __typename?: 'Query', scales: Array<{ __typename?: 'Scale', id: number, createdAt: any, title: string, parent?: boolean | null, teenager?: boolean | null, responsesCount: number }> };

export type RemoveScaleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveScaleMutation = { __typename?: 'Mutation', removeScale: boolean };

export type ScaleAnswerForEditQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ScaleAnswerForEditQuery = { __typename?: 'Query', scaleAnswer: { __typename?: 'ScaleAnswer', id: number, text: string, points: number } };

export type UpdateScaleAnswerMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateScaleAnswerInput;
}>;


export type UpdateScaleAnswerMutation = { __typename?: 'Mutation', updateScaleAnswer: { __typename?: 'ScaleAnswer', id: number, text: string, points: number } };

export type CreateScaleAnswerMutationVariables = Exact<{
  input: CreateScaleAnswerInput;
}>;


export type CreateScaleAnswerMutation = { __typename?: 'Mutation', createScaleAnswer: { __typename?: 'ScaleAnswer', id: number, text: string, points: number } };

export type ScaleDomainKeyForEditQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ScaleDomainKeyForEditQuery = { __typename?: 'Query', scaleDomainKey: { __typename?: 'ScaleDomainKey', id: number, domainName: string, description?: string | null, questions: Array<{ __typename?: 'ScaleQuestion', id: number, text: string }> } };

export type CreateScaleDomainKeyMutationVariables = Exact<{
  input: CreateScaleDomainKeyInput;
}>;


export type CreateScaleDomainKeyMutation = { __typename?: 'Mutation', createScaleDomainKey: { __typename?: 'ScaleDomainKey', id: number, domainName: string, description?: string | null, questions: Array<{ __typename?: 'ScaleQuestion', id: number, text: string }> } };

export type UpdateScaleDomainKeyMutationVariables = Exact<{
  input: UpdateScaleDomainKeyInput;
}>;


export type UpdateScaleDomainKeyMutation = { __typename?: 'Mutation', updateScaleDomainKey: { __typename?: 'ScaleDomainKey', id: number, domainName: string, description?: string | null, questions: Array<{ __typename?: 'ScaleQuestion', id: number, text: string }> } };

export type ScaleDomainKeyRangeForEditQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ScaleDomainKeyRangeForEditQuery = { __typename?: 'Query', scaleDomainKeyRange: { __typename?: 'ScaleDomainKeyRange', id: number, label: string, minValue: number, maxValue: number, description?: string | null } };

export type CreateScaleDomainKeyRangeMutationVariables = Exact<{
  input: CreateScaleDomainKeyRangeInput;
}>;


export type CreateScaleDomainKeyRangeMutation = { __typename?: 'Mutation', createScaleDomainKeyRange: { __typename?: 'ScaleDomainKeyRange', id: number, label: string, minValue: number, maxValue: number, description?: string | null } };

export type UpdateScaleDomainKeyRangeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateScaleDomainKeyRangeInput;
}>;


export type UpdateScaleDomainKeyRangeMutation = { __typename?: 'Mutation', updateScaleDomainKeyRange: { __typename?: 'ScaleDomainKeyRange', id: number, label: string, minValue: number, maxValue: number, description?: string | null } };

export type ScaleQuestionForEditQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ScaleQuestionForEditQuery = { __typename?: 'Query', scaleQuestion: { __typename?: 'ScaleQuestion', id: number, text: string, isReversed: boolean } };

export type CreateScaleQuestionMutationVariables = Exact<{
  input: CreateScaleQuestionInput;
}>;


export type CreateScaleQuestionMutation = { __typename?: 'Mutation', createScaleQuestion: { __typename?: 'ScaleQuestion', id: number, text: string, isReversed: boolean } };

export type UpdateScaleQuestionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateScaleQuestionInput;
}>;


export type UpdateScaleQuestionMutation = { __typename?: 'Mutation', updateScaleQuestion: { __typename?: 'ScaleQuestion', id: number, text: string, isReversed: boolean } };

export type ScaleResultRangeForEditQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ScaleResultRangeForEditQuery = { __typename?: 'Query', scaleResultRange: { __typename?: 'ScaleResultRange', id: number, label: string, minPoints: number, maxPoints: number, description?: string | null } };

export type CreateScaleResultRangeMutationVariables = Exact<{
  input: CreateScaleResultRangeInput;
}>;


export type CreateScaleResultRangeMutation = { __typename?: 'Mutation', createScaleResultRange: { __typename?: 'ScaleResultRange', id: number, label: string, minPoints: number, maxPoints: number, description?: string | null } };

export type UpdateScaleResultRangeMutationVariables = Exact<{
  input: UpdateScaleResultRangeInput;
}>;


export type UpdateScaleResultRangeMutation = { __typename?: 'Mutation', updateScaleResultRange: { __typename?: 'ScaleResultRange', id: number, label: string, minPoints: number, maxPoints: number, description?: string | null } };

export type ScaleForEditQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ScaleForEditQuery = { __typename?: 'Query', scale: { __typename?: 'Scale', id: number, title: string, description?: string | null, parent?: boolean | null, teenager?: boolean | null, requiresKnowledgeAccess: boolean } };

export type UpdateScaleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateScaleInput;
}>;


export type UpdateScaleMutation = { __typename?: 'Mutation', updateScale: { __typename?: 'Scale', id: number, title: string, description?: string | null, parent?: boolean | null, teenager?: boolean | null, requiresKnowledgeAccess: boolean } };

export type CreateScaleMutationVariables = Exact<{
  input: CreateScaleInput;
}>;


export type CreateScaleMutation = { __typename?: 'Mutation', createScale: { __typename?: 'Scale', id: number, title: string, description?: string | null, parent?: boolean | null, teenager?: boolean | null, requiresKnowledgeAccess: boolean } };

export type SurveyQuestionQueryVariables = Exact<{
  questionId: Scalars['Int']['input'];
}>;


export type SurveyQuestionQuery = { __typename?: 'Query', surveyQuestion: { __typename?: 'SurveyQuestion', id: number, text: string, multi?: boolean | null, answers: Array<{ __typename?: 'SurveyAnswer', id: number, text: string, open?: SurveyAnswerInputType | null }> } };

export type ReorderSurveyAnswersMutationVariables = Exact<{
  input: ReorderItemsInput;
}>;


export type ReorderSurveyAnswersMutation = { __typename?: 'Mutation', reorderQuestionAnswers: boolean };

export type RemoveSurveyAnswerMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveSurveyAnswerMutation = { __typename?: 'Mutation', removeSurveyAnswer: boolean };

export type SurveySectionQueryVariables = Exact<{
  sectionId: Scalars['Int']['input'];
}>;


export type SurveySectionQuery = { __typename?: 'Query', surveySection: { __typename?: 'SurveySection', id: number, title?: string | null, description?: string | null, questions: Array<{ __typename?: 'SurveyQuestion', id: number, text: string, multi?: boolean | null, required?: boolean | null, answers: Array<{ __typename?: 'SurveyAnswer', id: number, text: string, open?: SurveyAnswerInputType | null }> }> } };

export type ReorderQuestionsMutationVariables = Exact<{
  input: ReorderItemsInput;
}>;


export type ReorderQuestionsMutation = { __typename?: 'Mutation', reorderSectionQuestions: boolean };

export type RemoveSurveyQuestionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveSurveyQuestionMutation = { __typename?: 'Mutation', removeSurveyQuestion: boolean };

export type SurveyResponseDetailsQueryVariables = Exact<{
  surveyId: Scalars['Int']['input'];
  responseId: Scalars['Int']['input'];
}>;


export type SurveyResponseDetailsQuery = { __typename?: 'Query', survey: { __typename?: 'Survey', id: number, title: string, sections: Array<{ __typename?: 'SurveySection', id: number, title?: string | null, questions: Array<{ __typename?: 'SurveyQuestion', id: number, text: string, multi?: boolean | null, required?: boolean | null }> }> }, surveyResponse: { __typename?: 'SurveyResponse', id: number, createdAt: any, lastResponseAt?: any | null, status: SurveyResponseStatus, completionPercentage: number, questionResponses: Array<{ __typename?: 'SurveyQuestionResponse', id: number, openResponse?: string | null, questionSnapshot?: { __typename?: 'QuestionSnapshot', text: string, required: boolean, multi: boolean } | null, answerSnapshot?: { __typename?: 'AnswerSnapshot', text: string, open?: SurveyAnswerInputType | null } | null, question: { __typename?: 'SurveyQuestion', id: number, text: string } }> } };

export type SurveyResponsesQueryVariables = Exact<{
  surveyId: Scalars['Int']['input'];
}>;


export type SurveyResponsesQuery = { __typename?: 'Query', survey: { __typename?: 'Survey', id: number, title: string }, surveyResponses: Array<{ __typename?: 'SurveyResponse', id: number, createdAt: any, startedAt?: any | null, completedAt?: any | null, status: SurveyResponseStatus, completionPercentage: number, lastResponseAt?: any | null }> };

export type SurveyQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SurveyQuery = { __typename?: 'Query', survey: { __typename?: 'Survey', id: number, createdAt: any, title: string, sections: Array<{ __typename?: 'SurveySection', id: number, title?: string | null, description?: string | null, compact: boolean, questions: Array<{ __typename?: 'SurveyQuestion', id: number, text: string, multi?: boolean | null, answers: Array<{ __typename?: 'SurveyAnswer', id: number, text: string, open?: SurveyAnswerInputType | null }> }> }> } };

export type ReorderSectionsMutationVariables = Exact<{
  input: ReorderItemsInput;
}>;


export type ReorderSectionsMutation = { __typename?: 'Mutation', reorderSurveySections: boolean };

export type RemoveSurveySectionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveSurveySectionMutation = { __typename?: 'Mutation', removeSurveySection: boolean };

export type SurveysQueryVariables = Exact<{ [key: string]: never; }>;


export type SurveysQuery = { __typename?: 'Query', surveys: Array<{ __typename?: 'Survey', id: number, createdAt: any, title: string, parent?: boolean | null, teenager?: boolean | null, responsesCount: number }> };

export type RemoveSurveyMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveSurveyMutation = { __typename?: 'Mutation', removeSurvey: boolean };

export type SurveyAnswerForEditQueryVariables = Exact<{
  answerId: Scalars['Int']['input'];
}>;


export type SurveyAnswerForEditQuery = { __typename?: 'Query', surveyAnswer: { __typename?: 'SurveyAnswer', id: number, text: string, open?: SurveyAnswerInputType | null } };

export type UpdateSurveyAnswerMutationVariables = Exact<{
  updateAnswerInput: UpdateSurveyAnswerInput;
}>;


export type UpdateSurveyAnswerMutation = { __typename?: 'Mutation', updateSurveyAnswer: { __typename?: 'SurveyAnswer', id: number, text: string, open?: SurveyAnswerInputType | null } };

export type CreateSurveyAnswerMutationVariables = Exact<{
  createAnswerInput: CreateSurveyAnswerInput;
}>;


export type CreateSurveyAnswerMutation = { __typename?: 'Mutation', createSurveyAnswer: { __typename?: 'SurveyAnswer', id: number, text: string, open?: SurveyAnswerInputType | null } };

export type SurveyQuestionForEditQueryVariables = Exact<{
  questionId: Scalars['Int']['input'];
}>;


export type SurveyQuestionForEditQuery = { __typename?: 'Query', surveyQuestion: { __typename?: 'SurveyQuestion', id: number, text: string, multi?: boolean | null, required?: boolean | null } };

export type UpdateSurveyQuestionMutationVariables = Exact<{
  updateQuestionInput: UpdateSurveyQuestionInput;
}>;


export type UpdateSurveyQuestionMutation = { __typename?: 'Mutation', updateSurveyQuestion: { __typename?: 'SurveyQuestion', id: number, text: string, multi?: boolean | null, required?: boolean | null } };

export type CreateSurveyQuestionMutationVariables = Exact<{
  createQuestionInput: CreateSurveyQuestionInput;
}>;


export type CreateSurveyQuestionMutation = { __typename?: 'Mutation', createSurveyQuestion: { __typename?: 'SurveyQuestion', id: number, text: string, multi?: boolean | null, required?: boolean | null } };

export type SurveySectionForEditQueryVariables = Exact<{
  sectionId: Scalars['Int']['input'];
}>;


export type SurveySectionForEditQuery = { __typename?: 'Query', surveySection: { __typename?: 'SurveySection', id: number, title?: string | null, description?: string | null, compact: boolean } };

export type UpdateSurveySectionMutationVariables = Exact<{
  updateSectionInput: UpdateSurveySectionInput;
}>;


export type UpdateSurveySectionMutation = { __typename?: 'Mutation', updateSurveySection: { __typename?: 'SurveySection', id: number, title?: string | null, description?: string | null, compact: boolean } };

export type CreateSurveySectionMutationVariables = Exact<{
  createSectionInput: CreateSurveySectionInput;
}>;


export type CreateSurveySectionMutation = { __typename?: 'Mutation', createSurveySection: { __typename?: 'SurveySection', id: number, title?: string | null, description?: string | null, compact: boolean } };

export type SurveyForEditQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SurveyForEditQuery = { __typename?: 'Query', survey: { __typename?: 'Survey', id: number, title: string, parent?: boolean | null, teenager?: boolean | null, requiresKnowledgeAccess: boolean } };

export type UpdateSurveyMutationVariables = Exact<{
  updateSurveyInput: UpdateSurveyInput;
}>;


export type UpdateSurveyMutation = { __typename?: 'Mutation', updateSurvey: { __typename?: 'Survey', id: number, title: string, parent?: boolean | null, teenager?: boolean | null, requiresKnowledgeAccess: boolean } };

export type CreateSurveyMutationVariables = Exact<{
  createSurveyInput: CreateSurveyInput;
}>;


export type CreateSurveyMutation = { __typename?: 'Mutation', createSurvey: { __typename?: 'Survey', id: number, title: string, parent?: boolean | null, teenager?: boolean | null, requiresKnowledgeAccess: boolean } };

export type UserForEditQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type UserForEditQuery = { __typename?: 'Query', user: { __typename?: 'User', id: number, email: string, firstName: string, lastName: string, groups?: Array<{ __typename?: 'Group', id: number, name: string }> | null } };

export type AllGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllGroupsQuery = { __typename?: 'Query', groups: Array<{ __typename?: 'Group', id: number, name: string, description?: string | null }> };

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: number, email: string, firstName: string, lastName: string } };

export type CreateUserMutationVariables = Exact<{
  createUserInput: CreateUserDto;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: number, email: string, firstName: string, lastName: string } };

export type AddUserToGroupMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  groupId: Scalars['Int']['input'];
}>;


export type AddUserToGroupMutation = { __typename?: 'Mutation', addUserToGroup: boolean };

export type RemoveUserFromGroupMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  groupId: Scalars['Int']['input'];
}>;


export type RemoveUserFromGroupMutation = { __typename?: 'Mutation', removeUserFromGroup: boolean };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, createdAt: any, lastLoginAt?: any | null, email: string, firstName: string, lastName: string, groups?: Array<{ __typename?: 'Group', id: number, name: string, description?: string | null }> | null }> };

export type RemoveUserMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', removeUser: boolean };


export const RefreshTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshTokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]} as unknown as DocumentNode<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const GetCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lastLoginAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const PingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Ping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ping"}}]}}]} as unknown as DocumentNode<PingQuery, PingQueryVariables>;
export const ForgotPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ForgotPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resetUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forgotPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"resetUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resetUrl"}}}]}]}}]} as unknown as DocumentNode<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const LoginUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<LoginUserMutation, LoginUserMutationVariables>;
export const ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResetPasswordDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reset"}}}]}]}}]} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const GroupForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GroupForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GroupForEditQuery, GroupForEditQueryVariables>;
export const AllPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<AllPermissionsQuery, AllPermissionsQueryVariables>;
export const UpdateGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateGroupInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateGroupInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateGroupInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const CreateGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createGroupInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGroupDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createGroupInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createGroupInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CreateGroupMutation, CreateGroupMutationVariables>;
export const UpdateGroupPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateGroupPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permissionIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGroupPermissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"permissionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permissionIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateGroupPermissionsMutation, UpdateGroupPermissionsMutationVariables>;
export const GroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<GroupsQuery, GroupsQueryVariables>;
export const RemoveGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveGroupMutation, RemoveGroupMutationVariables>;
export const ReorderScaleAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReorderScaleAnswers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReorderItemsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reorderScaleAnswers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ReorderScaleAnswersMutation, ReorderScaleAnswersMutationVariables>;
export const RemoveScaleAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveScaleAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeScaleAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveScaleAnswerMutation, RemoveScaleAnswerMutationVariables>;
export const RemoveScaleDomainKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveScaleDomainKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeScaleDomainKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveScaleDomainKeyMutation, RemoveScaleDomainKeyMutationVariables>;
export const UpdateScaleDomainKeyInDomainKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScaleDomainKeyInDomainKeys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateScaleDomainKeyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScaleDomainKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateScaleDomainKeyInDomainKeysMutation, UpdateScaleDomainKeyInDomainKeysMutationVariables>;
export const UpdateScaleResultRangeTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScaleResultRangeType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resultRangeType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScaleResultRangeType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resultRangeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resultRangeType"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resultRangeType"}}]}}]}}]} as unknown as DocumentNode<UpdateScaleResultRangeTypeMutation, UpdateScaleResultRangeTypeMutationVariables>;
export const ScaleDomainKeyRangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ScaleDomainKeyRanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domainKeyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scaleDomainKeyRanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"domainKeyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domainKeyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"minValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ScaleDomainKeyRangesQuery, ScaleDomainKeyRangesQueryVariables>;
export const RemoveScaleDomainKeyRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveScaleDomainKeyRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeScaleDomainKeyRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveScaleDomainKeyRangeMutation, RemoveScaleDomainKeyRangeMutationVariables>;
export const ReorderScaleQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReorderScaleQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReorderItemsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reorderScaleQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ReorderScaleQuestionsMutation, ReorderScaleQuestionsMutationVariables>;
export const RemoveScaleQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveScaleQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeScaleQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveScaleQuestionMutation, RemoveScaleQuestionMutationVariables>;
export const RemoveScaleResultRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveScaleResultRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeScaleResultRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveScaleResultRangeMutation, RemoveScaleResultRangeMutationVariables>;
export const ScaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Scale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"consistencyError"}},{"kind":"Field","name":{"kind":"Name","value":"resultRangeType"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isReversed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resultRanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"minPoints"}},{"kind":"Field","name":{"kind":"Name","value":"maxPoints"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"domainKeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ScaleQuery, ScaleQueryVariables>;
export const ScalesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Scales"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scales"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","name":{"kind":"Name","value":"teenager"}},{"kind":"Field","name":{"kind":"Name","value":"responsesCount"}}]}}]}}]} as unknown as DocumentNode<ScalesQuery, ScalesQueryVariables>;
export const RemoveScaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveScale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeScale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveScaleMutation, RemoveScaleMutationVariables>;
export const ScaleAnswerForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ScaleAnswerForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scaleAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}}]}}]} as unknown as DocumentNode<ScaleAnswerForEditQuery, ScaleAnswerForEditQueryVariables>;
export const UpdateScaleAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScaleAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateScaleAnswerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScaleAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}}]}}]} as unknown as DocumentNode<UpdateScaleAnswerMutation, UpdateScaleAnswerMutationVariables>;
export const CreateScaleAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateScaleAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateScaleAnswerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createScaleAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}}]}}]} as unknown as DocumentNode<CreateScaleAnswerMutation, CreateScaleAnswerMutationVariables>;
export const ScaleDomainKeyForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ScaleDomainKeyForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scaleDomainKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]} as unknown as DocumentNode<ScaleDomainKeyForEditQuery, ScaleDomainKeyForEditQueryVariables>;
export const CreateScaleDomainKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateScaleDomainKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateScaleDomainKeyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createScaleDomainKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]} as unknown as DocumentNode<CreateScaleDomainKeyMutation, CreateScaleDomainKeyMutationVariables>;
export const UpdateScaleDomainKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScaleDomainKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateScaleDomainKeyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScaleDomainKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateScaleDomainKeyMutation, UpdateScaleDomainKeyMutationVariables>;
export const ScaleDomainKeyRangeForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ScaleDomainKeyRangeForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scaleDomainKeyRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"minValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ScaleDomainKeyRangeForEditQuery, ScaleDomainKeyRangeForEditQueryVariables>;
export const CreateScaleDomainKeyRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateScaleDomainKeyRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateScaleDomainKeyRangeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createScaleDomainKeyRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"minValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CreateScaleDomainKeyRangeMutation, CreateScaleDomainKeyRangeMutationVariables>;
export const UpdateScaleDomainKeyRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScaleDomainKeyRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateScaleDomainKeyRangeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScaleDomainKeyRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"minValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<UpdateScaleDomainKeyRangeMutation, UpdateScaleDomainKeyRangeMutationVariables>;
export const ScaleQuestionForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ScaleQuestionForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scaleQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isReversed"}}]}}]}}]} as unknown as DocumentNode<ScaleQuestionForEditQuery, ScaleQuestionForEditQueryVariables>;
export const CreateScaleQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateScaleQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateScaleQuestionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createScaleQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isReversed"}}]}}]}}]} as unknown as DocumentNode<CreateScaleQuestionMutation, CreateScaleQuestionMutationVariables>;
export const UpdateScaleQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScaleQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateScaleQuestionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScaleQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isReversed"}}]}}]}}]} as unknown as DocumentNode<UpdateScaleQuestionMutation, UpdateScaleQuestionMutationVariables>;
export const ScaleResultRangeForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ScaleResultRangeForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scaleResultRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"minPoints"}},{"kind":"Field","name":{"kind":"Name","value":"maxPoints"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ScaleResultRangeForEditQuery, ScaleResultRangeForEditQueryVariables>;
export const CreateScaleResultRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateScaleResultRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateScaleResultRangeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createScaleResultRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"minPoints"}},{"kind":"Field","name":{"kind":"Name","value":"maxPoints"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CreateScaleResultRangeMutation, CreateScaleResultRangeMutationVariables>;
export const UpdateScaleResultRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScaleResultRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateScaleResultRangeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScaleResultRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"minPoints"}},{"kind":"Field","name":{"kind":"Name","value":"maxPoints"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<UpdateScaleResultRangeMutation, UpdateScaleResultRangeMutationVariables>;
export const ScaleForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ScaleForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","name":{"kind":"Name","value":"teenager"}},{"kind":"Field","name":{"kind":"Name","value":"requiresKnowledgeAccess"}}]}}]}}]} as unknown as DocumentNode<ScaleForEditQuery, ScaleForEditQueryVariables>;
export const UpdateScaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateScaleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","name":{"kind":"Name","value":"teenager"}},{"kind":"Field","name":{"kind":"Name","value":"requiresKnowledgeAccess"}}]}}]}}]} as unknown as DocumentNode<UpdateScaleMutation, UpdateScaleMutationVariables>;
export const CreateScaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateScale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateScaleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createScale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","name":{"kind":"Name","value":"teenager"}},{"kind":"Field","name":{"kind":"Name","value":"requiresKnowledgeAccess"}}]}}]}}]} as unknown as DocumentNode<CreateScaleMutation, CreateScaleMutationVariables>;
export const SurveyQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveyQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"open"}}]}}]}}]}}]} as unknown as DocumentNode<SurveyQuestionQuery, SurveyQuestionQueryVariables>;
export const ReorderSurveyAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReorderSurveyAnswers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReorderItemsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reorderQuestionAnswers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ReorderSurveyAnswersMutation, ReorderSurveyAnswersMutationVariables>;
export const RemoveSurveyAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveSurveyAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeSurveyAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveSurveyAnswerMutation, RemoveSurveyAnswerMutationVariables>;
export const SurveySectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveySection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveySection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sectionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"open"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SurveySectionQuery, SurveySectionQueryVariables>;
export const ReorderQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReorderQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReorderItemsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reorderSectionQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ReorderQuestionsMutation, ReorderQuestionsMutationVariables>;
export const RemoveSurveyQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveSurveyQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeSurveyQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveSurveyQuestionMutation, RemoveSurveyQuestionMutationVariables>;
export const SurveyResponseDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveyResponseDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"required"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"surveyResponse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastResponseAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"questionResponses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"questionSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}}]}},{"kind":"Field","name":{"kind":"Name","value":"answerSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"open"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SurveyResponseDetailsQuery, SurveyResponseDetailsQueryVariables>;
export const SurveyResponsesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveyResponses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"surveyResponses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"lastResponseAt"}}]}}]}}]} as unknown as DocumentNode<SurveyResponsesQuery, SurveyResponsesQueryVariables>;
export const SurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Survey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"compact"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"open"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multi"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SurveyQuery, SurveyQueryVariables>;
export const ReorderSectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReorderSections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReorderItemsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reorderSurveySections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ReorderSectionsMutation, ReorderSectionsMutationVariables>;
export const RemoveSurveySectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveSurveySection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeSurveySection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveSurveySectionMutation, RemoveSurveySectionMutationVariables>;
export const SurveysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Surveys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","name":{"kind":"Name","value":"teenager"}},{"kind":"Field","name":{"kind":"Name","value":"responsesCount"}}]}}]}}]} as unknown as DocumentNode<SurveysQuery, SurveysQueryVariables>;
export const RemoveSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveSurveyMutation, RemoveSurveyMutationVariables>;
export const SurveyAnswerForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveyAnswerForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"answerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"answerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"open"}}]}}]}}]} as unknown as DocumentNode<SurveyAnswerForEditQuery, SurveyAnswerForEditQueryVariables>;
export const UpdateSurveyAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSurveyAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateAnswerInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSurveyAnswerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSurveyAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateAnswerInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateAnswerInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"open"}}]}}]}}]} as unknown as DocumentNode<UpdateSurveyAnswerMutation, UpdateSurveyAnswerMutationVariables>;
export const CreateSurveyAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSurveyAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createAnswerInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSurveyAnswerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSurveyAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createAnswerInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createAnswerInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"open"}}]}}]}}]} as unknown as DocumentNode<CreateSurveyAnswerMutation, CreateSurveyAnswerMutationVariables>;
export const SurveyQuestionForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveyQuestionForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"required"}}]}}]}}]} as unknown as DocumentNode<SurveyQuestionForEditQuery, SurveyQuestionForEditQueryVariables>;
export const UpdateSurveyQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSurveyQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateQuestionInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSurveyQuestionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSurveyQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateQuestionInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateQuestionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"required"}}]}}]}}]} as unknown as DocumentNode<UpdateSurveyQuestionMutation, UpdateSurveyQuestionMutationVariables>;
export const CreateSurveyQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSurveyQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createQuestionInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSurveyQuestionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSurveyQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createQuestionInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createQuestionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"required"}}]}}]}}]} as unknown as DocumentNode<CreateSurveyQuestionMutation, CreateSurveyQuestionMutationVariables>;
export const SurveySectionForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveySectionForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveySection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sectionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"compact"}}]}}]}}]} as unknown as DocumentNode<SurveySectionForEditQuery, SurveySectionForEditQueryVariables>;
export const UpdateSurveySectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSurveySection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateSectionInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSurveySectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSurveySection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateSectionInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateSectionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"compact"}}]}}]}}]} as unknown as DocumentNode<UpdateSurveySectionMutation, UpdateSurveySectionMutationVariables>;
export const CreateSurveySectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSurveySection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createSectionInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSurveySectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSurveySection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createSectionInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createSectionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"compact"}}]}}]}}]} as unknown as DocumentNode<CreateSurveySectionMutation, CreateSurveySectionMutationVariables>;
export const SurveyForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveyForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","name":{"kind":"Name","value":"teenager"}},{"kind":"Field","name":{"kind":"Name","value":"requiresKnowledgeAccess"}}]}}]}}]} as unknown as DocumentNode<SurveyForEditQuery, SurveyForEditQueryVariables>;
export const UpdateSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateSurveyInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSurveyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateSurveyInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateSurveyInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","name":{"kind":"Name","value":"teenager"}},{"kind":"Field","name":{"kind":"Name","value":"requiresKnowledgeAccess"}}]}}]}}]} as unknown as DocumentNode<UpdateSurveyMutation, UpdateSurveyMutationVariables>;
export const CreateSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createSurveyInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSurveyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createSurveyInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createSurveyInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","name":{"kind":"Name","value":"teenager"}},{"kind":"Field","name":{"kind":"Name","value":"requiresKnowledgeAccess"}}]}}]}}]} as unknown as DocumentNode<CreateSurveyMutation, CreateSurveyMutationVariables>;
export const UserForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UserForEditQuery, UserForEditQueryVariables>;
export const AllGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<AllGroupsQuery, AllGroupsQueryVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateUserInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateUserInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateUserInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createUserInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createUserInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createUserInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const AddUserToGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddUserToGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserToGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}]}}]} as unknown as DocumentNode<AddUserToGroupMutation, AddUserToGroupMutationVariables>;
export const RemoveUserFromGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserFromGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserFromGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}]}}]} as unknown as DocumentNode<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>;
export const UsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"EnumValue","value":"ASC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastLoginAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const RemoveUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveUserMutation, RemoveUserMutationVariables>;